import { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";

type Props = {
    src: string,
    preview?: string
}

const Container = styled.div`
    width: 100%;

    img {
        width: 100%;
    }

    .preview {
        position: fixed;

        z-index: 1000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        background: rgba(0,0,0,.6);

        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
`;

const ImageView: React.FC<Props> = ({ src, preview }) => {

    const [showFullscreen, setFullScreen] = useState(false);
    const [fit, setFit] = useState<'fit-width' | 'fit-height'>('fit-width');
    const previewRef = useRef<HTMLImageElement>(null);

    const showFS = useCallback(() => {
        setFullScreen(true);
    }, [setFullScreen])

    const hideFS = useCallback(() => {
        setFullScreen(false);
    }, [setFullScreen])

    const updateStyle = useCallback(() => {
        if (previewRef.current) {
            const wRatio = window.innerWidth / window.innerHeight;
            const iRatio = previewRef.current.offsetWidth / previewRef.current.offsetHeight;

            if (wRatio >= iRatio) {
                setFit('fit-height')
            } else {
                setFit('fit-width')
            }
        }
    }, [previewRef, setFit])

    useEffect(() => {
        updateStyle();

        window.addEventListener('resize', updateStyle);

        return () => {
            window.removeEventListener('resize', updateStyle);
        }

    }, [updateStyle])

    return <Container>
        <img src={src} alt="" onClick={showFS} />
        {showFullscreen && <div className={`preview ${fit}`} onClick={hideFS}>
            <img ref={previewRef} src={preview || src} alt="" />
        </div>}
    </Container>
}

export default ImageView;
